module.exports = __webpack_public_path__ + "img/violet_outline_.5ae78d0b.png";